import React from 'react';
import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { goalTypeToUrl } from '../utils/goalTypeUtils';
import { getGoalDisplayTitle, getGoalIconUrl, onGoalIconError } from '../utils/goalDisplayTitle';
import { getStatusCircleClass } from '../utils/euStatusUtils';
import { getTrendArrow, getTrendArrowClass } from '../utils/euTrendUtils';

/**
 * Desktop home goal flip card — same structure/styling as pre-redesign.
 * Front: SDG icon + status/trend column. Back: navigation links.
 * EU: status + progress. UN: progress only; targets link on back (CP-1).
 */
const GoalTile = ({ goal, goalType, onSelect, copy = {} }) => {
  const indicatorsTitle = copy.goalCardIndicatorsTitle || 'View All Indicators';
  const indicatorsSubtitle =
    copy.goalCardIndicatorsSubtitle || 'View all indicators for this goal';
  const targetsTitle = copy.goalCardTargetsTitle || 'Indicators grouped by Targets';
  const base = `/${goalTypeToUrl(goalType)}/goal/${goal.id}`;
  const goalColor = goal.color || goal.acf?.goal_color || '#039dda';

  return (
    <div className="goal-item" style={{ '--goal-color': goalColor }}>
      <div className="card-container">
        <div className="card front">
          <div className="goal-item-image-container">
            <div className="goal-item-art">
              <img
                src={getGoalIconUrl(goal)}
                alt={getGoalDisplayTitle(goal)}
                className="goal-icon"
                onError={(e) => onGoalIconError(e, goal)}
              />
            </div>
            <div className="goal-item-status">
              {goalType !== 'un' && goal?.computed?.goal_semaphore_status && (
                <div
                  className={`status-circle status-circle-medium ${getStatusCircleClass(
                    goal.computed.goal_semaphore_status
                  )}`}
                  title={goal.computed.goal_semaphore_status}
                />
              )}
              {goal?.computed?.goal_trend_status ? (
                <span
                  className={`trend-arrow trend-arrow-large ${getTrendArrowClass(
                    goal.computed.goal_trend_status
                  )}`}
                  title={goal.computed.goal_trend_status}
                >
                  {getTrendArrow(goal.computed.goal_trend_status).arrow}
                </span>
              ) : (
                <span className="trend-arrow trend-arrow-large trend-arrow-default">—</span>
              )}
            </div>
          </div>
        </div>

        <div className="card back" style={{ backgroundColor: goalColor }}>
          <div className="back-content">
            <Row className="goal-item-footer">
              {goalType === 'un' && (
                <Link to={`${base}/targets`} onClick={() => onSelect?.(goal)}>
                  <div className="goal-grid-button-see-all-targets">
                    <div className="goal-grid-button-title-container">
                      <h4>{targetsTitle}</h4>
                    </div>
                    <span className="chevron">→</span>
                  </div>
                </Link>
              )}
              <Link to={`${base}/indicators`} onClick={() => onSelect?.(goal)}>
                <div className="goal-grid-button-see-all-data">
                  <div className="goal-grid-button-title-container">
                    <h4>{indicatorsTitle}</h4>
                    <p>{indicatorsSubtitle}</p>
                  </div>
                  <span className="chevron">→</span>
                </div>
              </Link>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoalTile;
